import '../styles/Spinner.css'

const Spinner = () => {
    return(
        <div className="lds-hourglass"></div>
    );
}

export default Spinner;